/**
 * formato que convierte una cadena y retornar fecha y hora
 * @param date string
 * @returns string
 */
export const dateTimeFormat = (date: string) => {
    const nDate = new Date(date);
    if (nDate) {
        return new Intl.DateTimeFormat('default', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true,
        })
            .format(nDate)
            .toString();
    }

    return '';
};
